import { render, staticRenderFns } from "./ReferralCodeModal.vue?vue&type=template&id=bc439480&scoped=true"
import script from "./ReferralCodeModal.vue?vue&type=script&lang=js"
export * from "./ReferralCodeModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralCodeModal.vue?vue&type=style&index=0&id=bc439480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc439480",
  null
  
)

export default component.exports